export default {
  dayOfWeek () {
    return this.$dayOfWeek(this.schedule.date, 'DD/MM/YYYY')
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/transfer/resources/computed.js